import jQuery from 'jquery';
const $ = jQuery;

window.jQuery = $;
window.$ = $;

import 'cssuseragent';
import 'jquery.easing';

// import PerfectScrollbar from 'perfect-scrollbar';

import Swiper, { Pagination, Autoplay } from 'swiper';

// configure Swiper to use modules
Swiper.use([Pagination, Autoplay]);

// import ImgLazyLoad from './module/img-lazy-load';

document.oncontextmenu = function () {
  return false;
};

// ---------------------------------------------

class Loader {
  hideLoader() {
    $('div.Loader').fadeOut(500); // 500ミリ秒（0.5秒）かけてフェードアウト
  }
}

class LoadHandler {
  constructor() {
    this.elements = [
      { selector: 'div.Keyvisual__bg', delay: 500 },
      { selector: 'div.KeyvisualM60', delay: 1500 },
      { selector: '.CommonHeader--special', delay: 3000 },
    ];
  }

  hideSpot() {
    $('.Spot').fadeOut(500); // 500ミリ秒（0.5秒）かけてフェードアウト
    $('html, body').css({
      overflow: 'auto',
      height: 'auto',
    });
    console.log('click!!');
  }

  addClassAfterDelay() {
    this.elements.forEach(({ selector, delay }) => {
      setTimeout(() => {
        $(selector).addClass('JsLoaded--Done');
      }, delay);
    });
  }
}

class ScrollIdApp {
  constructor() {
    this.speed = 400;

    // window.innerWidthを使ってブラウザのビューポートの幅を取得
    if (window.innerWidth <= 1280) {
      // SP
      this.adjust = -54;
    } else {
      // PC
      this.adjust = -80;
    }
  }

  ScrollAddId() {
    $('.TitleLocation').each((index, element) => {
      const idValue = 'TitleLocation-' + (index + 1);
      $(element).attr('data-id', idValue).attr('id', idValue);
    });
  }

  ScrollIdAppClick() {
    $('a[href^="#"], button[href^="#"]').click((event) => {
      event.preventDefault();
      const target = $($(event.currentTarget).attr('href'));
      const position = target.offset().top + this.adjust;
      $('body,html').animate({ scrollTop: position }, this.speed, 'swing');
    });
  }
}

class ScrollHandler {
  constructor(elementClass, doneClass) {
    this.elementClass = elementClass;
    this.doneClass = doneClass;
    $(window).on('scroll', () => this.checkScroll());
  }

  checkScroll() {
    $(this.elementClass).each((index, element) => {
      const windowHeight = $(window).height();
      const scrollPosition = $(window).scrollTop();
      const elementPosition = $(element).offset().top;

      if (scrollPosition + windowHeight * 0.75 >= elementPosition) {
        $(element).addClass(this.doneClass);
      }
    });
  }
}

class ScrollIntroduction2 extends ScrollHandler {
  constructor() {
    super('.JsShow.JsShow--Introduction2', 'JsDone');
  }

  checkScroll() {
    super.checkScroll();
    if ($('.JsShow.JsShow--Introduction2').hasClass('JsDone')) {
      setTimeout(() => {
        $('.Introduction2__Image').addClass('JsDone');

        setTimeout(() => {
          $('.Introduction2__Wrap').addClass('JsDone');
        }, 500);
      }, 1000);
    }
  }
}

class ScrollIntroduction3 extends ScrollHandler {
  constructor() {
    super('.JsShow.JsShow--Introduction3', 'JsDone');
  }

  checkScroll() {
    super.checkScroll();
    if ($('.JsShow.JsShow--Introduction3').hasClass('JsDone')) {
      $('.Introduction3__Images')
        .children('div')
        .each((index, element) => {
          setTimeout(() => {
            $(element).addClass('JsDone');
          }, 200 * index);
        });

      setTimeout(() => {
        $('.Introduction3__Images').addClass('JsDone');

        setTimeout(() => {
          $('.Introduction3__Wrap').addClass('JsDone');
        }, 500);
      }, 200 * $('.Introduction3__Images').children('div').length + 500);
    }
  }
}

new ScrollHandler('.ProfileImage', '.ProfileContent');

let scrollIdApp = new ScrollIdApp();
new Loader();
new ScrollHandler('.JsShow', 'JsDone');
new ScrollIntroduction2();
new ScrollIntroduction3();

$(window).on('load', function () {
  //スクロールさせない
  $('html, body').css({
    overflow: 'hidden',
    height: '100%',
  });

  scrollIdApp.ScrollAddId();
  scrollIdApp.ScrollIdAppClick();
  let loader = new Loader();
  // let loadHandler = new LoadHandler();
  loader.hideLoader();

  $('.Spot__Close').click(() => {
    const handler = new LoadHandler();
    handler.hideSpot();
    handler.addClassAfterDelay();
  });
});
